import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePhoto } from '../api/updatePhoto';

type Props = {
    onSuccess: () => void;
};

export const useUpdatePhoto = ({ onSuccess }: Props) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updatePhoto,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userPhoto'] });
            onSuccess();
        },
    });
};
